import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'markdownLinkBlank' })
export class MarkdownLinkBlankPipe implements PipeTransform {
    transform(markdown: string): string {
        // Caso 1: [texto](url)
        const linkedTextPattern = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
        markdown = markdown.replace(
            linkedTextPattern,
            `<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>`,
        );

        // Caso 2: <url>
        const autoLinkPattern = /<(https?:\/\/[^>\s]+)>/g;
        markdown = markdown.replace(
            autoLinkPattern,
            `<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>`,
        );

        return markdown;
    }
}
